export function full_keyword_search(a, keyword) {
  for (let i = 0; i < a.length; i++) {
    if (a[i].fValue.toLowerCase().includes(keyword.toLowerCase())) {
      return i; // First match found, return the index
    }
  }
  return null; // Match not found
}
